import { splitDiff, type DiffRow } from '../../lib/line-diff';

function cellClass(row: DiffRow, side: 'left' | 'right'): string {
  const value = side === 'left' ? row.left : row.right;
  const other = side === 'left' ? row.right : row.left;
  if (value === null) return 'bo-diff-cell bo-diff-gap';
  if (other === null || value !== other) return side === 'left' ? 'bo-diff-cell bo-diff-remove' : 'bo-diff-cell bo-diff-add';
  return 'bo-diff-cell';
}

export function SideBySideDiff({ before, after }: { before: string; after: string }) {
  const rows = splitDiff(before, after);
  return (
    <div className="bo-diff">
      <div className="bo-diff-row bo-diff-head">
        <div className="bo-diff-cell">Old</div>
        <div className="bo-diff-cell">New</div>
      </div>
      {rows.map((row, index) => (
        <div key={index} className="bo-diff-row">
          <div className={cellClass(row, 'left')}>{row.left ?? ''}</div>
          <div className={cellClass(row, 'right')}>{row.right ?? ''}</div>
        </div>
      ))}
    </div>
  );
}
